import fetch from '@/utils/fetch'
/**
 * sidebar
 *
 * @export
 * @param {any} data
 * @returns
 */
export function sidebar(uid) {
  return fetch({
    url: '/api_user/service/aw/mul/ow/user/sidebar',
    method: 'post',
    data: {
      pfCode: 'ofs',
      uid: uid
    }
  })
}
/**
 * 获取七牛token
 *
 * @export
 * @returns
 */
export function getToken() {
  return fetch({
    url: '/api_user/service/aw/mul/ow/common/get_token',
    method: 'post',
    data: {}
  })
}

/**
 * 获取表头
 *
 * @export
 * @returns
 */
export function fetchThead(data) {
  return fetch({
    url: '/api_user/service/aw/mul/ow/ds/column/fetch',
    method: 'post',
    data
  })
}

/**
 * 获取用户表头
 *
 * @export
 * @returns
 */
export function fetchUserThead(data) {
  return fetch({
    url: '/api_user/service/aw/mul/ow/ds/column/table_code_all',
    method: 'post',
    data
  })
}

/**
 * 表头显示隐藏
 *
 * @export
 * @returns
 */
export function isShowThead(data) {
  return fetch({
    url: '/api_user/service/aw/mul/ow/ds/column/is_show',
    method: 'post',
    data
  })
}

/**
 * 表头显示隐藏
 *
 * @export
 * @returns
 */
export function updateSortThead(data) {
  return fetch({
    url: '/api_user/service/aw/mul/ow/ds/column/update_sort',
    method: 'post',
    data
  })
}

/**
 * 按照昵称查询用户
 *
 * @export
 * @param {any} data
 * @returns
 */
export function fetchUser(data) {
  return fetch({
    url: '/api_user/service/uc/user/fetch_by_nick_name',
    method: 'post',
    data
  })
}

/**
 * 按照昵称查询机构用户
 *
 * @export
 * @param {any} data
 * @returns
 */
export function fetchOrganUser(data) {
  return fetch({
    url: '/api_zaiart/service/zaiart/exhibition/organ/name',
    method: 'post',
    data
  })
}
/**
 * 城市查询
 *
 * @export
 * @param {any} data
 * @returns
 */
export function fetchCity(data) {
  return fetch({
    url: '/api_user/service/aw/mul/ow/common/get_country_by_type_and_parent_id',
    method: 'post',
    data
  })
}

/**
 * 设置城市
 *
 * @export
 * @param {any} data
 * @returns
 */
export function setCity(data) {
  return fetch({
    url: '/api_user/service/aw/mul/ow/common/get_country_recursion',
    method: 'post',
    data
  })
}
